import "./Mixin-header-style";

export class MixinHeader {
    constructor(element: HTMLElement){
        element.classList.add("mixin-header");
    }
}
